/** @format */
import { TriggerRulesProps } from 'src/containers/MonitorCreate/AlarmRule/constants'

export interface SelectInstanceProps {
  className?: string
  pageType?: 'tacticsAlarm'
  policyId?: string
  triggerRules?: TriggerRulesProps[]
  productType: string
  region?: string
  disabled?: boolean // 禁用
  allInstance?: boolean // 是否支持全部实例
  optionalInstance?: boolean // 是否支持自选实例
  IPpackage?: boolean // 弹性IP支持批量新建
  defaultInstance?: InstanceItem[] // 默认已选实例
  instanceIdsTotal?: number // 已选实例总数
  setInstaneIdsTotal?: (val: number) => void // 设置已选总数
  instanceMaxLength?: number // 已选实例最大上限
  isGroupFilter?: boolean // 自选实例是否支持实例组筛选
  isRegionFilter?: boolean // 自选实例是否支持region
  instanceGroup?: boolean // 是否支持实例组
  defaultGroup?: number // 默认实例组
  groupListProps?: GroupItemProps[] // 实例组list
  projectDimens?: boolean // 是否支持项目制
  projectDisabled?: boolean // 是否禁用项目制
  defalutProject?: number // 默认项目
  defaultRadioValue?: number // 选择资源类型
  getSelectedInstaces?: () => Promise<InstanceItem[]> // 获取策略下所选资源方法
  selectContainer?: string // select定位位置
  batchSearch?: boolean // 是否支持批量搜索
  // eslint-disable-next-line max-len
  onChange?: (radio: number, value?: string | InstanceItem[] | number) => void // change回调
}
// 实例Item
export interface InstanceItem {
  instanceId: string
  instanceName: string
  region?: string
  instanceIP?: string
  productType?: number
  properties?: any
  thresholdBindStatus?: 0 | 1
}
// 项目Item
export interface ProjectItemProp {
  ProjectId: number
  ProjectName: string
}
// 实例组Item
export interface GroupItemProps {
  groupId: number
  groupName: string
}

export interface InstanceDialogProps {
  className?: string
  productType: string
  visible?: boolean
  region?: string
  instanceMaxLength?: number
  selectedInstance: InstanceItem[] //选中的实例
  isGroupFilter?: boolean
  groupListProps?: GroupItemProps[] // 实例组list
  isRegionFilter?: boolean
  batchSearch?: boolean // 批量搜索实例
  setSelectedInstance: (value: InstanceItem[]) => void
  disabled?: boolean
}

export interface FilterFormState {
  filterType: 'instanceId' | 'instanceName' | 'instanceGroup'
  filterValue: string
  group: string
  region?: string
}
export const initFilterForm: FilterFormState = {
  filterType: 'instanceName',
  filterValue: '',
  group: '',
  region: ''
}
